(function () {
    "use strict"

    // Calculate the base URL once
    var baseUrl = window.location.hash.split('/')[1] || '';

    //// this directive compiles an html string or dom into a template
    angular.module('formApp')

    //// this directive compiles an html string or dom into a template
    .constant('Constants',
    {
        // Defines constants that can used throughout the application by injecting 'Constants'
        ausDateFormat: 'DD/MM/YYYY',
        responseDateFormat: 'YYYY-MM-DD',
        minimumDate: "1900-01-01",
        defaultDateOption: '4',
        defaultFeedbackStatus: '2',
        clientPageId: '1-5',
        clientPageSectionCode: 'clients',
        accessSectionCode: 'accesstouser',
        summaryNavTabNum: 90,
        systemNavTabNum: 100,
        Url: {
            landing: "/",
            logout: "/logout",
            landing: baseUrl,
            privacy: baseUrl + "/privacy",
            tools: baseUrl + "/tools",
            internal: baseUrl + "/internal",
            introduction: baseUrl + "/introduction",
            manageFeedbacks: baseUrl + "/manageFeedbacks",
            manageComplaints: baseUrl + "/manageComplaints",
            privacyStaffMemberLanding: baseUrl + "/privacyStaffMemberLanding",
            feedbackStaffMemberLanding: baseUrl + "/feedbackStaffMemberLanding",
            firstIncidentFormPage: baseUrl + "/incident/1/servicedetails",
            firstFollowUpFormPage: baseUrl + "/incidentCoordination/1/followup",
            firstRiskAssessmentFormPage: baseUrl + "/riskAssessment/1/riskassessment",
            firstNotificationFormPage: baseUrl + "/notification/1/notification",
            firstInvestigationFormPage: baseUrl + "/investigation/1/investigation",
            firstPracticeImprovementFormPage: baseUrl + "/practiceImprovement/1/practiceimprovement",
            firstComplaintFormPage: baseUrl + "/complaint/1/yourdetails",
            firstComplaintRegisteredFormPage: baseUrl + "/complaintRegistered/1/complainantdetails",
            firstFeedbackCoordinationFormPage: baseUrl + "/feedbackCoordination/1/feedbackcoordination",
            secondFeedbackCoordinationFormPage: baseUrl + "/feedbackCoordination/2/complainshistory",
            firstFeedbackAssessmentFormPage: baseUrl + "/feedbackAssessment/1/assessment",
            firstFeedbackInvestigateFormPage: baseUrl + "/feedbackInvestigate/1/investigate",
            firstFeedbackRespondFormPage: baseUrl + "/feedbackRespond/1/respond",
            firstFeedbackPracticeImprovementFormPage: baseUrl + "/feedbackPracticeImprovement/1/practiceimprovement",
            firstFeedbackAdditionalInfoFormPage: baseUrl + "/feedbackAdditionalInfo/1/feedback",
            nonMajorSummary: baseUrl + "/incident/4/incidentchecklist",
            saveDraft: baseUrl + "/incident/100/savedraft",
            managerReturn: baseUrl + "/incident/100/managerreturn",
            withdrawIncident: baseUrl + "/incident/100/withdrawincident",
            getResponseByEmailURL: __env.apiUrl + "/Home/GetResponseByEmail",
            getConfigDataURL: __env.apiUrl + "/Home/GetConfigData",
            getConfigDataPublicURL: __env.apiUrl + "/Home/GetPublicConfigData",
            getApplicationLastUpdateDateURL: __env.apiUrl + "/Home/GetApplicationLastUpdateDate",
            getUserProfileData: __env.apiUrl + "/Home/GetUserProfileData",
            getFeedbackAssigneesURL: function (feedbackId, IsDHVisible) 
                { return __env.apiUrl + "/User/FeedbackAssignees/" + feedbackId + "/" + IsDHVisible; },
            getSubmitIncidentURL: __env.apiUrl + "/Feedback/PublicSubmitFeedback",
            getSubmitIncidentRegisteredUserURL: __env.apiUrl + "/Feedback/SubmitFeedback",
            getSaveIncidentRegisteredUserURL: __env.apiUrl + "/Feedback/SaveFeedback",
            getFeedbacksURL: __env.apiUrl + "/Feedback/GetFeedbacks",
            getFeedbackByIdURL: function (id) { return __env.apiUrl + "/Feedback/" + id; },
            assignFeedbackURL: __env.apiUrl + "/Feedback/AssignFeedback",
            getLinkableFeedbacksURL: function (feedbackId) { return __env.apiUrl + "/Feedback/LinkableFeedbacks/" + feedbackId; },
            saveFeedbackLinkURL: __env.apiUrl + "/Feedback/SaveFeedbackLink",
            removeFeedbackLinkURL: __env.apiUrl + "/Feedback/RemoveFeedbackLink",
            getPublicSaveDocumentURL: __env.apiUrl + "/Feedback/PublicSaveDocument",
            getSaveDocumentURL: __env.apiUrl + "/Feedback/SaveDocument",
            getPublicGetDocumentURL: __env.apiUrl + "/Feedback/PublicGetDocument",
            getGetDocumentURL: __env.apiUrl + "/Feedback/GetDocument",
            getPublicDeleteDocumentURL: __env.apiUrl + "/Feedback/PublicDeleteDocument",
            getDeleteDocumentURL: __env.apiUrl + "/Feedback/DeleteDocument",
            getSaveIncidentForDocumentUploadURL: __env.apiUrl + "/Feedback/SaveIncidentForDocumentUpload",
            getPublicSaveIncidentForDocumentUploadURL: __env.apiUrl + "/Feedback/PublicSaveIncidentForDocumentUpload",
            getSaveFeedbackCaseNotesURL: __env.apiUrl + "/Feedback/SaveFeedbackCaseNotes",
            getWithdrawFeedbackURL: __env.apiUrl + "/Feedback/WithdrawFeedback",
            getApproveNonMajorIncidentCEOURL: __env.apiUrl + "/Home/ApproveNonMajorIncidentCEO",
            getFollowUpSummaryResponseAndConfigURL: __env.apiUrl + "/FollowUp/GetFollowUpSummaryResponseAndConfig",
            getFollowUpResponseAndConfigURL: __env.apiUrl + "/FollowUp/GetFollowUpResponseAndConfigByFollowUpId",
            securedHealthCheckUrl: __env.apiUrl + "/HealthCheck/scheck",
            getSubmitSubmitFollowUpURL: __env.apiUrl + "/FollowUp/SubmitFollowUp",
            getSaveFollowUpURL: __env.apiUrl + "/FollowUp/SaveFollowUp",
            geUpdateFeedbackStatusUpURL: __env.apiUrl + "/Feedback/UpdateFeedbackStatus",
            getFeedbackPdf: function (id) { return __env.apiUrl + "/pdf/GetFeedbackPdf/" + id; },
            getAllFormsPdf: function (id) { return __env.apiUrl + "/pdf/GetAllFormsPdf/" + id; },
            getComplaintsRegisteredPdf: function (id) { return __env.apiUrl + "/pdf/GetComplaintsRegisteredPdf/" + id; },
            getComplaintsUnRegisteredPdf: function (id) { return __env.apiUrl + "/pdf/GetComplaintsUnRegisteredPdf/" + id; },
            getComplaintsAllFormsPdf: function (id) { return __env.apiUrl + "/pdf/GetComplaintsAllFormsPdf/" + id; },
            getComplaintsFeedbackUnRegistered: function (id) { return __env.apiUrl + "/Feedback/GetComplaintsFeedbackUnRegistered/" + id; },
            getFeedbackHistoryURL: __env.apiUrl + "/history/GetHistory",
            getGetDocumentTemplatesURL: __env.apiUrl + "/DocumentTemplate/GetDocumentTemplates",
            getReOpenFeedbackURL: __env.apiUrl + "/Feedback/ReOpenFeedback",
            deleteFeedbackURL: __env.apiUrl + "/Feedback/DeleteFeedback",
            getCsvExtractUrl: __env.apiUrl + "/Feedback/GetCsvExtract",
            toggleFeedbackSensitivityURL: __env.apiUrl + "/Feedback/ToggleFeedbackSensitivity",
            getGetDocumentTemplateFileURL: function (documentTemplateId) { return __env.apiUrl + "/DocumentTemplate/GetDocumentTemplateFile/" + documentTemplateId; }
        },
        NotifyType: {
            notification: { css: 'text-success', icon: '#icon-info' },
            error: { css: 'text-danger', icon: '#icon-warning' }
        },
        SubmitType: {
            toMgr: 'ToMgr',
            toCEO: 'ToCEO',
            toDHHS: 'ToDHHS',
            toDHHSMgr: 'ToDHHSMgr',
            nonMajorCEO: 'NonMajorCEO',
            adhocDHHS: 'AdhocDHHS'
        },
        RepeatingItemState: {
            adding: 'Adding',
            editing: 'Editing',
            viewing: 'Viewing'
        },
        ManageIncidentState: {
            view: 'View',
            bulkEdit: 'BulkEdit'
        },
        ImpactType: {
            major: { code: 1, text: 'Major' },
            nonMajor: { code: 2, text: 'Non-Major' },
            unknown: { code: 3, text: 'Unknown' }
        },
        Role: {
            spReadOnly: 'ReadOnlyUser',
            Requestor: 'Requestor',
            StaffMember: 'StaffMember',
            PrivacyOfficer: 'PrivacyOfficer',
            PrivacyManager: 'PrivacyManager',
            IncidentManager: 'IncidentManager',
            Investigator: 'Investigator',
            ComplaintsManager: 'ComplaintsManager',
            ActionOfficer: 'ActionOfficer',
            FMS_Admin: 'FMS_Admin',
            FMS_ComplaintsAdmin: 'FMS_ComplaintsAdmin',
            FMS_Level3User: 'FMS_Level3User'
        },
        FeedbackType: {
            Privacy: 1,
            Complaint: 2
        },
        ConfigTemplate: {
            incident: 1,
            incidentCoordination: 2,
            riskAssessment: 3,
            notification: 4,
            investigation: 5,
            practiceImprovement: 6,
            complaint: 7,
            user: 8,
            organisation: 9,
            complaintRegistered: 11,
            feedbackCoordination: 12,
            feedbackAssessment: 13,
            feedbackInvestigate: 15,
            feedbackRespond: 16,
            feedbackPracticeImprovement: 17,
            feedbackAdditionalInfo: 20
        },
        FollowUpStatus: {
            draft: 1,
            submitted: 2
        },
        Status: {
            Draft: 1,
            Submitted: 2,
            InProgress: 3,
            Withdrawn: 4,
            Closed: 5,
            Approved: 6
        },
        RetrieveHistoryType: {
            Assignment: 1,
            Recategorisation: 2,
            ExternalOversightDueDate: 3,
            RevisedDueDate: 4,
            LinkingUnLinking: 5,
            EditHistory: 6,
            EditFollowup: 7,
            OverdueNotification: 8
        },
        AppConfig: {
            googlePlacesAPIKey: __env.GooglePlacesAPIKey,
            isTestRecaptcha: __env.IsTestRecaptcha,
            googleRecaptchaTestSecret: __env.GoogleRecaptchaTestSecret,
            googleRecaptchaTestKey: __env.GoogleRecaptchaTestKey
        },
        ComplaintsFormType: {
            registered: 11,
            unRegistered: 7
        },
        Popup: {
            savedElsewhere: {
                severity: '',
                title: 'Unable to save',
                text: '<p>You are unable to save this complaint as another user has updated this complaint while you were making changes.</p><br><p>You will need to close this complaint and re-open it in order to make your changes. Any changes made will not be saved.</p>',
                type: 'info',
                okButtonText: 'Close',
            },
            reviewComplaintErrors: {
                severity: '',
                title: 'Error',
                text: 'Mandatory information is required',
                type: 'info',
                okButtonText: 'Ok',
            },
            reopenIncident: {
                severity: '',
                title: 'Re-open this incident?',
                text: '<p>Do you want to <strong>re-open</strong> this incident ?<br /></p>',
                type: 'confirm',
                okButtonText: 'Yes',
                cancelButtonText: 'No'
            },
            linkPrivacyIncident: {
                severity: 'linkPrivacyIncident',
                title: 'Link this privacy incident?',
                text: '<p>You have selected to <strong>link</strong> privacy incident <strong>{{params.formattedRef}}</strong> to another privacy incident. <br />Please choose the other privacy incident from the list below and enter a reason.</p>',
                type: 'confirm',
                okButtonText: 'Confirm Linking',
                cancelButtonText: 'Cancel',
                questions: [
                    {
                        question: 'Other Incident',
                        code: 'linkablePrivacyIncidents',
                        controlType: 'typeahead',
                        options: 'linkableprivacyincidents',
                        showAsRequired: 'true',
                        validations: [
                            {
                                level: "inline",
                                rule: "notEmpty(p$, 'linkablePrivacyIncidents') === true",
                                summaryMessage: "",
                                inlineMessage: "Please enter a report reference"
                            }
                        ]
                    },
                    {
                        question: 'Reason for Linking',
                        code: 'linkReason',
                        controlType: 'select',
                        showAsRequired: 'true',
                        options: 'privacylinkreasons',
                        validations: [
                            {
                                level: "inline",
                                rule: "notEmpty(p$, 'linkReason') === true",
                                summaryMessage: "",
                                inlineMessage: "Please enter a reason to link"
                            }
                        ]
                    }
                ]
            },
            incidentNotAccessible: {
                severity: '',
                title: 'Unable to view the incident',
                text: "<p>You don't have sufficient permissions to view Incident ID <strong> {{ params.formattedRef }}</strong>.</p >",
                type: 'info',
                okButtonText: 'Close'
            },
            confirmDeleteComplaint: {
                severity: '',
                title: 'Delete feedback',
                text: 'Are you sure you want to delete the feedback?',
                type: 'confirm',
                okButtonText: 'Delete',
                cancelButtonText: 'Cancel'
            },
            confirmToMakeRecordSensitive: {
                severity: '',
                title: 'Lock feedback',
                text: 'Are you sure you want to make the feedback sensitive?',
                type: 'confirm',
                okButtonText: 'Yes',
                cancelButtonText: 'Cancel'
            },
            confirmToMakeRecordInsensitive: {
                severity: '',
                title: 'Unlock feedback',
                text: 'Are you sure you want to make the feedback not sensitive?',
                type: 'confirm',
                okButtonText: 'Yes',
                cancelButtonText: 'Cancel'
            }
        },
        Notification: {
            reopenIncidentSuccessful: {
                type: "notification",
                message: "Incident: {{ref}} has been re-opened successfully."
            },
            reopenIncidentFailed: { message: 'Incident {{ref}} re-open failed.', type: "error" },
            incidentUpdatedSinceReadTime: { message: 'You are unable to re-open incident {{ref}} as another user has updated this incident report.', type: "error" },
            complaintHasValidationErrors: {
                message: 'Please <a ng-click="$scope.goToPage({{tabNum}}, {{pageUrl}})">click</a> here to see the errors in the form',
                type: "error"
            },
            deleteComplaintSuccessful: {
                type: 'notification',
                message: 'Complaint {{ref}} has been deleted successfully.'
            }
        },
        Messages: {
            manageReportsPageTitle: 'Feedback Management System Manage Reports page',
            linkPrivacyProgress: 'Linking privacy incidents'
        }
    })

}());